/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getExportPlanQueryParamsSchema = z.object({
  Year: z.coerce.number().int(),
  Month: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getExportPlan200Schema = z.any();

export const getExportPlanQueryResponseSchema = z.lazy(
  () => getExportPlan200Schema,
);
